<template>
  <div>
    <div style=" background-color: #b3a258; color: #fff; padding: 10px 0; ">
      <span :style="fontSize">{{topic}} </span>
      <v-btn class="default" icon @click="isShow = !isShow">
        <v-icon>{{ isShow ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </div>
    <v-expand-transition >
      <v-simple-table v-show="isShow" style="margin: 10px;" >
        <template v-slot:default >
          <thead>
            <tr >
              <th class="text-center" v-for="(data, index) in datas.header" :key="index" v-html="data" :style="fontSize"></th>
            </tr>
          </thead>
          <tbody v-for="(data, index) in datas.data" :key="index">
            <tr >
              <td rowspan="3" v-html="data.name" :style="fontSize"></td>
              <td rowspan="3" :style="fontSize">{{data.guest}}</td>
              <td
                v-for="(price, priceIndex) in data.low"
                :key="priceIndex"
                :class="price.class"
                :style="fontSize"
              >{{price.name}}</td>
            </tr>
            <tr>
              <td
                v-for="(price, priceIndex) in data.mid"
                :key="priceIndex"
                :class="price.class"
                :style="fontSize"
              >{{price.name}}</td>
            </tr>
            <tr>
              <td
                v-for="(price, priceIndex) in data.high"
                :key="priceIndex"
                :class="price.class"
                :style="fontSize"
              >{{price.name}}</td>
            </tr>
          </tbody>
          <tr v-for="(data, index) in datas.remark" :key="index" >
            <td v-bind:colspan="Object.keys(datas.header).length">
              <div v-html="data" class="remark" :style="fontSize"></div>
            </td>
          </tr>
        </template>
      </v-simple-table>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: "Point",
  props: {
    datas: {}
  },
  data() {
    return {
      lang: this.$route.params.lang,
      isShow: false,
      fontSize: {},
      topic: ''
    };
  },
  methods: {
    loadStyle() {
      if (this.lang == 'en') {
        this.topic = 'DAILY POINTS VALUE';
      }
      else if (this.lang == 'th') { 
        this.topic = 'ตารางคะแนนประจำวัน';
        this.fontSize = {
          "fontSize": "20px",
          "font-family": "Browallia New"
        };
      }
      else if(this.lang == 'cn') {
        this.topic = '每日积分值';
      }
    }
  },
  mounted() {
    this.loadStyle();
  }
};
</script>

<style scoped>
* {
  --avc-color: #b3a258;
  --text-color: #585859;
  --special-price-bg: #696a6d;
}
.resort-name {
  color: var(--text-color);
  background-color: white;
}
.guest {
  color: var(--text-color);
  background-color: white;
}
.normal-price {
  color: var(--text-color);
  background-color: white;
  width: 100px;
}
.special-price {
  color: var(--special-price-bg);
  background-color: var(--special-price-bg);
  width: 100px;
}
.low {
  background-color: #e6dfca;
}
.mid {
  background-color: #d4c9a0;
}
.high {
  background-color: #c3b57b;
}
.table,
tr {
  border-spacing: 0px;
  border-collapse: collapse;
  border: 1px solid var(--avc-color);
}
th {
  background-color: #c4c6c7;
  text-align: center;
}
tbody,
td {
  border-bottom: 1px solid #eee;
  padding: 10px 5px;
}
.box-remark-one {
  background-color: #696a6d;
  letter-spacing: 0.5em;
  margin: 2px;
  height: 20px;
  width: 100px;
}
.box-remark-two {
  background-color: #696a6d;
  letter-spacing: 0.5em;
  margin: 2px;
  height: 20px;
  width: 100px;
}
.remark {
  font-size: 0.9em;
}
@media only screen and (max-width: 567px)  {
  .expand {
    padding: 0 100px;
  }
}
</style>